import * as React from 'react';
import { observer } from 'mobx-react';
import { ONE } from '../../../constans/common-constants';
import './paging.scss';

interface IProps {
    currentPage: number;
    totalRecords: number;
    pageSize: number;
}

const PagingRecordsCounts: React.FC<IProps> = ({ currentPage, pageSize, totalRecords }) => {
  const currentPageOnTotalRecords = currentPage * pageSize;
  const startPageCount = (currentPageOnTotalRecords) - (pageSize - ONE);
  const endPageCount = currentPageOnTotalRecords < totalRecords ? currentPageOnTotalRecords : totalRecords;
  return (
    <div className='records-count'>
      {totalRecords &&
        <>
          <span>{`${startPageCount}-${endPageCount}`}</span> <b>of</b> <span>{totalRecords}</span>
        </>
      }
    </div>
  );
};

export default observer(PagingRecordsCounts);